/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum Distribution {
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
  RANDOM = 'RANDOM',
}

export function DistributionFromJSON(json: any): Distribution {
  return DistributionFromJSONTyped(json, false)
}

export function DistributionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Distribution {
  return json as Distribution
}

export function DistributionToJSON(value?: Distribution | null): any {
  return value as any
}
